var map = {
	"./icon-account-add.svg": "e561",
	"./icon-account.svg": "3290",
	"./icon-home-xs.svg": "e060",
	"./icon-receive-money-xs.svg": "8a8f",
	"./icon-result-10-20.svg": "0a47",
	"./icon-result-20-50.svg": "c41f",
	"./icon-result-gt-50.svg": "f2c9",
	"./icon-result-lt-5k.svg": "407f",
	"./icon-rocket-xs.svg": "754d",
	"./icon-savings-xs.svg": "a37b",
	"./icon-user-group.svg": "3b38",
	"./icon_arrow_left.svg": "5898",
	"./icon_arrow_right.svg": "179f",
	"./icon_check.svg": "dc77",
	"./icon_check_white.svg": "f493",
	"./icon_close.svg": "f4cb",
	"./icon_close_back.svg": "fbfc",
	"./icon_confirmation.svg": "fab4",
	"./icon_email.svg": "2595",
	"./icon_error.svg": "b2df",
	"./icon_female.svg": "83b4",
	"./icon_gender_other.svg": "c3a4",
	"./icon_info.svg": "286a",
	"./icon_info_text.svg": "c64f",
	"./icon_info_text_transperent.svg": "a76e",
	"./icon_male.svg": "7a0e",
	"./icon_office.svg": "6ee3",
	"./icon_question_mark.svg": "70ca",
	"./icon_user.svg": "f2ec",
	"./illustration.svg": "38f2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ef18";